import { css } from '@emotion/react';
import { useDevToolsStore } from '@frontend/devtools';
import { useDashboardWidget } from '@frontend/grid-dashboard';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Chip, NakedButton, useTooltip } from '@frontend/design-system';
import { ScheduleRequestsTrackingIds } from '../../trackingIds';
import { ScheduleRequestItemHeader, ScheduleRequestItemHeaderProps } from '../ScheduleRequestItemHeader';

export const ScheduleRequestWidgetListItem = (props: ScheduleRequestItemHeaderProps) => {
  const { listItem } = props;
  const isDebugModeOn = useDevToolsStore((state) => state.options.isDebugModeOn);
  const debugStyle =
    isDebugModeOn && listItem.linkHash === 'v2' ? { backgroundColor: theme.colors.critical10 } : undefined;
  const { currentSize } = useDashboardWidget();
  const isNarrowSize = currentSize === 'large-narrow';
  const { tooltipProps, triggerProps, Tooltip } = useTooltip({ trigger: 'hover' });

  return (
    <div
      css={[containerStyle, debugStyle]}
      data-trackingId={ScheduleRequestsTrackingIds.requestListItemAccordion}
      style={{ borderBottom: `1px solid ${theme.colors.neutral10}` }}
      key={listItem?.id ?? ''}
    >
      <ScheduleRequestItemHeader
        {...props}
        locationChip={(locationName) => (
          <>
            {isNarrowSize ? (
              <NakedButton {...triggerProps} css={locationIconButtonStyle}>
                <Icon name='location' size={16} />
                <Tooltip {...tooltipProps}>{locationName}</Tooltip>
              </NakedButton>
            ) : (
              <Chip.Location variant='neutral' tooltipLabel={locationName}>
                {locationName}
              </Chip.Location>
            )}
          </>
        )}
      />
    </div>
  );
};

const containerStyle = css({
  borderRadius: theme.borderRadius.small,
  backgroundColor: theme.colors.white,
  padding: theme.spacing(0.5, 2),
  marginBottom: theme.spacing(1),
  boxShadow: theme.shadows.light,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

const locationIconButtonStyle = css`
  margin-left: auto;
  margin-right: ${theme.spacing(1)};
`;
